module.exports = __webpack_public_path__ + "static/media/ketogenic-icon.d1a47033.png";